export default __webpack_public_path__ + "static/media/React.78e61144.png";